import { render, staticRenderFns } from "./KonvaDraggedCell.vue?vue&type=template&id=64a07c90"
import script from "./KonvaDraggedCell.vue?vue&type=script&lang=js"
export * from "./KonvaDraggedCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports